import * as React from "react";
import styled from "../../styles";
import theme from "../../styles/theme";

type colors = typeof theme.color.typography;

const AirplaneSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1509 25.6875C15.5812 25.6875 15.1702 25.484 14.918 25.0771C14.6657 24.6702 14.45 24.1616 14.271 23.5513L11.7075 14.8477L2.89404 12.2598C2.30811 12.0807 1.82389 11.8691 1.44141 11.625C1.05892 11.3727 0.867676 10.9658 0.867676 10.4043C0.867676 9.96484 1.04264 9.58643 1.39258 9.26904C1.74251 8.95166 2.17383 8.69531 2.68652 8.5L23.6826 0.455566C23.9674 0.349772 24.2319 0.268392 24.4761 0.211426C24.7284 0.146322 24.9562 0.11377 25.1597 0.11377C25.5584 0.11377 25.8717 0.227702 26.0996 0.455566C26.3275 0.683431 26.4414 0.996745 26.4414 1.39551C26.4414 1.6071 26.4089 1.83496 26.3438 2.0791C26.2868 2.32324 26.2054 2.58773 26.0996 2.87256L18.104 23.7588C17.8761 24.3447 17.6035 24.8127 17.2861 25.1626C16.9688 25.5125 16.5903 25.6875 16.1509 25.6875ZM12.2568 12.9922L20.6553 4.59375C20.9889 4.26009 21.3836 3.90609 21.8394 3.53174C22.2951 3.15739 22.7264 2.80745 23.1333 2.48193C22.6776 2.69352 22.2137 2.91325 21.7417 3.14111C21.2778 3.36084 20.8018 3.56429 20.3135 3.75146L3.80957 10.0015C3.72005 10.034 3.65902 10.0706 3.62646 10.1113C3.59391 10.1439 3.57764 10.1805 3.57764 10.2212C3.57764 10.2619 3.59391 10.2985 3.62646 10.3311C3.66715 10.3636 3.73633 10.3921 3.83398 10.4165L12.2568 12.9922ZM16.3462 23.002C16.3869 23.002 16.4235 22.9816 16.4561 22.9409C16.4886 22.9002 16.5212 22.8351 16.5537 22.7456L22.8037 6.2417C22.9909 5.74528 23.1984 5.26107 23.4263 4.78906C23.6541 4.31706 23.8739 3.84912 24.0854 3.38525C23.7599 3.80029 23.4059 4.23975 23.0234 4.70361C22.6491 5.16748 22.2951 5.56624 21.9614 5.8999L13.563 14.2983L16.1387 22.7212C16.1712 22.8188 16.1997 22.888 16.2241 22.9287C16.2567 22.9775 16.2974 23.002 16.3462 23.002Z"
      fill="#fff"
    />
  </svg>
);

interface Props {
  colorPreset?: keyof colors;
}

export const AirplaneIcon = styled(AirplaneSVG)<Props>`
  path {
    fill: ${(p) =>
      p.color
        ? p.color
        : p.colorPreset
        ? p.theme.color.typography[p.colorPreset]
        : "#fff"};
  }
`;
